// ユーザー情報
const User = {
  namespaced: true,

  state: {
    user: {
      user_role: '',
      ftp_portalsite: [],
      kss_portalsite: [],
      cp_portalsite: [],
      shop_group_list: [],
      rent_shop_group_list: [],
      initial_camera_settings: null,
      f_homes_all_panorama: 0,
    },
  },
  getters: {
    getUser: state => {
      return state.user
    },
    getUserId: state => {
      return state.user.user_id
    },
    getFtpPortalsite: state => {
      return state.user.ftp_portalsite
    },
    getKssPortalsite: state => {
      return state.user.kss_portalsite
    },
    getCpPortalsite: state => {
      return state.user.cp_portalsite
    },
    getShopGroupList: state => {
      return state.user.shop_group_list
    },
    getRentShopGroupList: state => {
      return state.user.rent_shop_group_list
    },
    getInitialCameraSettings: state => {
      return state.user.initial_camera_settings
    },
    getFHomesAllPanorama: state => {
      return state.user.f_homes_all_panorama
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setInitialCameraSettings(state, setting) {
      state.user.initial_camera_settings = setting
    },
  },
  actions: {},
}

export default User
